import React, { Component } from "react";
import load from "../../ImageLoder";
import PageHOC from "../../PageHOC";
import CommonPhoneSlider from "../CommonPhoneSlider";
import Footer from "../Footer";

class ClinicalAllergyPage extends Component {
  render() {
    const { locale, t } = this.props;
    const sliderImages = [
      "allergy_slider_phone1.png",
      "allergy_slider_phone2.png",
      "allergy_slider_phone3.png",
    ];
    const sliderImageAlts = [
      "Screenshot of Allergy and Medications",
      "Screenshot of Allergy and Medications",
      "Screenshot of Allergy and Medications",
    ];
    const sliderImageIds = [
      "img1AllergySlider",
      "img2AllergySlider",
      "img3AllergySlider",
    ];
    const phoneSlider = (
      <CommonPhoneSlider
        backgoundImg={"clinical-allergy-bg.png"}
        sliderID="allergySlider"
        sliderTitle={t("Allergy Header")}
        sliderTitleID={"textAllergySliderTitle"}
        sliderText={t(
          "Provide you a close up on allergy and adverse drug reaction records"
        )}
        sliderTextID="textAllergySliderContent"
        sliderImages={sliderImages}
        sliderImageAlts={sliderImageAlts}
        sliderImageIds={sliderImageIds}
        autoPlay={5}
        {...this.props}
      />
    );
    return (
      <div
        className={`page-container page-container-${locale}`}
        id="MainContent"
      >
        {phoneSlider}
        <div className="container-fluid second-feature-section ">
          <div className="container">
            <div className="row vertical-align">
              <div
                data-aos="fade-left"
                className="col-md-6 col-sm-12 col-sm-push-6"
              >
                <div
                  id="textAllergySection1Title"
                  className="second-feature-title"
                >
                  {t("Allergy and adverse drug reaction record")}
                </div>
                <div
                  id="textAllergySection1Content"
                  className="second-feature-text"
                >
                  {t(
                    "Master your personal drug allergy and adverse drug reaction record"
                  )}
                </div>
              </div>

              <div className="col-md-6 col-sm-12 col-sm-pull-6">
                <img src={load(`./resources/images/empty.png`)} alt="" />
                <img
                  id="img1AllergySection1"
                  data-aos="fade-up"
                  data-aos-anchor-placement="center-center"
                  data-aos-offset="-300"
                  className="absolute-image back"
                  src={load(`./resources/images/allergy_p1_1.png`)}
                  alt=" "
                />
                <img
                  id="img2AllergySection1"
                  data-aos="fade-up"
                  data-aos-anchor-placement="center-center"
                  data-aos-offset="-300"
                  data-aos-delay="300"
                  className="absolute-image middle"
                  src={load(`./resources/images/${locale}/allergy_p1_2.png`)}
                  alt=" "
                />
                <img
                  id="img3AllergySection1"
                  data-aos="fade-up"
                  data-aos-anchor-placement="center-center"
                  data-aos-offset="-300"
                  className="absolute-image front"
                  src={load(`./resources/images/allergy_p1_3.png`)}
                  alt=" "
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid second-feature-section last-section">
          <div className="container">
            <div className="row vertical-align">
              <div data-aos="fade-right" className="col-md-6 col-sm-12">
                <div
                  id="textMyFamilySection2Title"
                  className="second-feature-title"
                >
                  {t("Educational Information")}
                </div>
                <div
                  id="textMyFamilySection2Content"
                  className="second-feature-text"
                >
                  {t(
                    "Learn more about allergy and adverse drug reaction with one tap"
                  )}
                </div>
              </div>
              <div className="col-md-6 col-sm-12">
                <img src={load(`./resources/images/empty.png`)} alt="" />
                <img
                  id="img1AllergySection2"
                  data-aos="fade-up"
                  data-aos-anchor-placement="center-center"
                  data-aos-offset="-300"
                  className="absolute-image back"
                  src={load(`./resources/images/${locale}/allergy_p2_1.png`)}
                  alt=" "
                />
                <img
                  id="img2AllergySection2"
                  data-aos="fade-up"
                  data-aos-anchor-placement="center-center"
                  data-aos-offset="-300"
                  data-aos-delay="300"
                  className="absolute-image middle"
                  src={load(`./resources/images/allergy_p2_2.png`)}
                  alt=" "
                />
              </div>
            </div>
          </div>
        </div>

        <div
          data-aos="fade-down"
          data-aos-offset="-200"
          className="second-video"
          alt={t("Video")}
        >
          <div ref={this.youtubeContainer} className="second-youtube-container">
            <iframe
              id="videoAllergy2"
              key={locale}
              className="second-responsive-iframe"
              title={t("Video des")}
              src="https://www.youtube.com/embed/CClV3wyUEfs"
              alt={t("Video")}
              tabIndex="0"
            ></iframe>
          </div>
        </div>

        <div className="empty-space-100"></div>

        <Footer {...this.props} />
      </div>
    );
  }
}

export default PageHOC(ClinicalAllergyPage);
